// extracted by mini-css-extract-plugin
export default {"app":"App_app__i8j4l","content":"App_content__H6EAn"};